module.exports = function() {
  return new Worker(__webpack_public_path__ + "44d5f96dccf763f1ab5f.worker.js");
};